import { mapActions, mapState } from 'vuex';
import loaderMixin from '@/mixins/loader';
import constants from '@/constants';
import { getAssetPath} from '@/utils/helpers';

const DEFAULT_AVATAR = getAssetPath('/images/Avatars/default.png');


export default {
  mixins: [
    loaderMixin,
  ],
  computed: {
    ...mapState('user', ['userData']),
    avatar() {
      if (this.userData && this.userData.avatarImage) {
        return this.userData.avatarImage;
      }
      return '';
    },
    showRemoveOption() {
      return this.avatar && this.avatar !== DEFAULT_AVATAR;
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentSmallPopup']),
    ...mapActions('user', ['uploadUserImage', 'resetUserImage', 'getAccountDetail']),
    ...mapActions('notifications', ['setErrorSideNotification', 'setSuccessSideNotification']),
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          resolve(reader.result.replace(/^data:image\/(png|jpg|jpeg);base64,/, ''));
        };
        reader.onerror = (error) => {
          reject(error);
        };
      });
    },
    onUpload() {
      this.$refs.fileinput.click();
    },
    onRemove() {
      this.resetUserImage()
        .then(() => {
          setTimeout(
            () => { this.setCurrentSmallPopup(); },
            constants.DEFAULT_SUCCESS_SIDE_NOTIFICATION_CLOSE_TIMEOUT,
          );
          this.setSuccessSideNotification('Your profile photo has been removed');
        })
        .then(this.getAccountDetail)
        .catch(() => {});
    },
    onChange() {
      this.loaderAdd();
      const formData = new FormData();
      formData.append('files', this.$refs.fileinput.files[0]);

      this.uploadUserImage(formData)
        .then(() => {
          this.loaderRemove();
          setTimeout(
            () => { this.setCurrentSmallPopup(); },
            constants.DEFAULT_SUCCESS_SIDE_NOTIFICATION_CLOSE_TIMEOUT,
          );
          this.setSuccessSideNotification('Your profile image has been submitted for review');
        })
        .then(this.getAccountDetail)
        .catch((e) => {
          const message = (e.response.data && e.response.data.message) ?
            e.response.data.message :
            'An error has occurred.';
          this.setErrorSideNotification(message);
          this.loaderRemove();
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-update-image/account-update-image.js